/** Browser SOAP draft cache. PostgreSQL Notes are the source of truth. */

export const SOAP_STORAGE_PREFIX = "emrbymd.v3.encounter.soap.";
export const SOAP_SERVER_PERSIST_KEY = "emrbymd.v3.soap.serverPersist";

export function soapStorageKey(encounterId) {
  return `${SOAP_STORAGE_PREFIX}${encounterId}`;
}

export function readSoapDraft(encounterId) {
  try {
    const raw = localStorage.getItem(soapStorageKey(encounterId));
    if (!raw) return { text: "", signed: false, savedAt: null, resolvedText: "" };
    const parsed = JSON.parse(raw);
    return {
      text: typeof parsed.text === "string" ? parsed.text : "",
      resolvedText: typeof parsed.resolvedText === "string" ? parsed.resolvedText : "",
      signed: parsed.signed === true,
      savedAt: parsed.savedAt || null,
    };
  } catch {
    return { text: "", signed: false, savedAt: null, resolvedText: "" };
  }
}

export function writeSoapDraft(encounterId, draft) {
  localStorage.setItem(
    soapStorageKey(encounterId),
    JSON.stringify({
      text: draft.text || "",
      resolvedText: draft.resolvedText || "",
      signed: !!draft.signed,
      savedAt: draft.savedAt || new Date().toISOString(),
    }),
  );
}

export function hasSoapContent(text) {
  return String(text || "").trim().length > 0;
}

/** Set localStorage emrbymd.v3.soap.serverPersist=off to disable server writes. */
export function isSoapServerPersistEnabled() {
  try {
    return localStorage.getItem(SOAP_SERVER_PERSIST_KEY) !== "off";
  } catch {
    return true;
  }
}
